import { AggregationService } from '@qdrant/qdrant-cloud-public-api/ui/v1/ui';
import { listUsersWithRoles } from '@qdrant/qdrant-cloud-public-api/ui/v1/ui/connect-query';
import { transport } from '@/api/transport';
import { queryOptions, createServiceQueries } from '@/connect-query';

export const aggregationService = createServiceQueries(AggregationService, {
  listUsersWithRolesQuery: (params) => queryOptions(listUsersWithRoles, params, { transport, select: (d) => d.items }),
});
